import * as Transfer from '../payments/legacy/services/api/Transfer';

/**
 * @deprecated Use `services/*` instead.
 */
export const Api = {
  Transfer,
};
